import { ReactNode } from 'react';

export function FilterSection({ children }: { children: ReactNode }) {
  return (
    <div className="py-2 filter-section px-2 text-sm flex justify-between items-center">
      {children}
    </div>
  );
}
